module.exports = "<div class=\"cover xl_wrap\" id=\"act_msgbox_common\" style=\"display:none;\"> <div class=\"xl_pop pop_type_1\" style=\"display:block\"> <div class=\"xl_pop_m\"> <p class=\"text_nor\" name=\"msgbox_info\"></p> </div> <div class=\"xl_pop_b\"> <a href=\"javascript:msgExit()\" class=\"btn_pop act_close_box\">取消</a> <a href=\"javascript:;\" class=\"btn_pop btn_ok act_close_box\" name=\"box_btn\">确定</a> </div> </div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/tpl/msgbox.tpl
// module id = 75
// module chunks = 2 3